// extracted by mini-css-extract-plugin
export default {"rootContainer":"RootLayout_rootContainer__Tdq7X","root":"RootLayout_root__xhPsY","studentRootContainer":"RootLayout_studentRootContainer__3qSmQ"};